export default "__VITE_ASSET__4$6i$Nwb__"